export default __webpack_public_path__ + "static/media/postReseller.10c2577a.png";